import * as React from 'react'

import { IPermitTypeField } from '~/client/graph'

interface IProps {
  typeField: IPermitTypeField
}

export default function PermitFormDividerField({
  typeField,
}: IProps): JSX.Element {
  return (
    <div className="row section-separator py20 overflow-hidden">
      <hr className="ba-none bt-light-input-border min-width30" />
      {typeField?.caption && (
        <span className="text small light bold lp15 uppercase mx10 tw:text-center tw:!flex-initial tw:min-w-0">
          {typeField.caption}
        </span>
      )}
      <hr className="ba-none bt-light-input-border min-width30" />
    </div>
  )
}
